export default {
    props: {
        resource: {
            required: true,
            type: Object
        },
        resourceName: {
            required: true,
            type: String
        }
    },

    methods: {
        redirect() {
            this.$emit('redirect', {routeName: this.redirectName, params: this.redirectParams})
        }
    },
    
    computed: {
        redirectName: function () {
            return `admin.${this.resourceName}.view`
        },
        redirectParams: function () {
            return {
                id: this.resource.id
            }
        }
    }
}
